import { render, staticRenderFns } from "./add-serve-dialog.vue?vue&type=template&id=1e19cd8f&scoped=true"
import script from "./add-serve-dialog.vue?vue&type=script&lang=js"
export * from "./add-serve-dialog.vue?vue&type=script&lang=js"
import style0 from "./add-serve-dialog.vue?vue&type=style&index=0&id=1e19cd8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e19cd8f",
  null
  
)

export default component.exports